import { render, staticRenderFns } from "./IconCardOutline.vue?vue&type=template&id=36000412&"
import script from "./IconCardOutline.vue?vue&type=script&lang=ts&"
export * from "./IconCardOutline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports